import { Box, Chip, Divider, List, ListItem, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { getAgendaStatusColor, getAgendaStatusText } from "../../organisms/accept-invitation-form/helper";
import { EmptyAgendaState } from "../../organisms/accept-invitation-form/agenda-section";
import { TConfiguredAgendaItem } from "../../organisms/accept-invitation-form/type";
import ScrollIndicatorWrapper from "../../atoms/scroll-indicator-wrapper";


interface AgendaListProps {
  agendas: TConfiguredAgendaItem[];
  selectedIndex: number;
  onSelectAgenda: (index: number) => void;
  showArchived: boolean;
}

export const AgendaList: React.FC<AgendaListProps> = ({ 
  agendas, 
  selectedIndex, 
  onSelectAgenda, 
  showArchived 
}) => {
  if (agendas.length === 0) {
    return <EmptyAgendaState showArchived={showArchived} />;
  }

  return (
    <ScrollIndicatorWrapper sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', minHeight: 0 }}>
      <List sx={{ p: 0 }}>
        {agendas.map((agenda, index) => (
          <AgendaListItem
            key={agenda.id || index}
            agenda={agenda}
            index={index}
            isSelected={selectedIndex === index}
            onClick={() => onSelectAgenda(index)}
          />
        ))}
      </List>
    </ScrollIndicatorWrapper>
  );
};

const AgendaListItem: React.FC<{
  agenda: TConfiguredAgendaItem;
  index: number;
  isSelected: boolean;
  onClick: () => void;
}> = ({ agenda, index, isSelected, onClick }) => (
  <>
    <ListItem disablePadding>
      <ListItemButton selected={isSelected} onClick={onClick}>
        <ListItemText
          primary={
            <Typography
              fontSize="14px" 
              color={isSelected ? 'primary' : 'text.primary'} 
              fontWeight={500} 
              noWrap
            >
              {agenda.title || "No Title Provided"}
            </Typography>
          }
          secondary={
            <Stack direction="row" justifyContent="space-between" alignItems="center" mt={0.5}>
              <Typography variant="caption" color="text.secondary">
                {agenda.formattedAgenda?.length || 0} questions
              </Typography>
              {agenda.status && (
                <Chip
                  label={getAgendaStatusText(agenda.status)}
                  color={getAgendaStatusColor(agenda.status)}
                  size="small"
                  variant="outlined"
                  sx={{ fontSize: '10px', height: '20px' }}
                />
              )}
            </Stack>
          }
        />
      </ListItemButton>
    </ListItem>
    <Divider variant="middle" />
  </>
);